import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { withTranslation } from "react-i18next";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import PropertyValueSelection from "./PropertyValueSelection";
import { bulkUpdateRequest } from "store/bulk/action";

const UpdateModal = ({show, onCloseClick, selectedIds, setTriggerApi, props, dataFields, setSelectedIds, setCheckedRows, model}: any) => {    
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const OnBulkUpdate = (keyValue: any) => {
        const result = selectedIds.map((id: any, index: any) => ({
            id: id,
            ...keyValue
          }));
        const handleSuccess = (body: any) => {
            setTriggerApi((triggerApi: boolean) => !triggerApi)
            onCloseClick()
            setSelectedIds([])
            setCheckedRows({})
        }
        const handleFailure = (body: any) => {
            onCloseClick()
        }
        dispatch(bulkUpdateRequest(model, result, handleSuccess, handleFailure))
    }
    
    return (
        <Modal backdrop="static" isOpen={show} toggle={onCloseClick} centered={true}>
            <ModalHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={onCloseClick}>
                <span className='text-light'>{props.t(`common.table.bulk_update`)} {selectedIds?.length} {props.t(`common.modals.records`)} </span>
            </ModalHeader>
            <ModalBody className='p-5 py-2'>
                <div className="mt-1">
                    <PropertyValueSelection t={props.t} OnBulkUpdate={OnBulkUpdate} onCloseClick={onCloseClick} dataFields={dataFields} />
                </div>
            </ModalBody>
        </Modal>
    ) as unknown as JSX.Element;
};

export default withTranslation()(UpdateModal);